import React from "react";
import localize, { LocKeys } from "../../constants/localizations";
import { templateSourceConstants } from "../../utils/template.util";

/**
 * Render a single template option row with a source label chip
 * ("Standard" / "Custom" — EXE-233, kept through the review revert).
 * Shared `customRenderOption` for every `CustomAutocomplete` template field —
 * pair with `buildTemplateOptions` (utils/template.util) for the option list.
 * Mirrors `customRenderLodSpecification` in orders/crud/parts/BuildingInformation.js.
 * @param {Object} props li props injected by the Autocomplete
 * @param {Object} option { label, value, source }
 * @returns
 */
const renderTemplateOption = (props, option) => {
	const isCustom = option.source === templateSourceConstants.CUSTOM;

	return (
		<li {...props} key={option.value}>
			<div className="d-flex align-items-center justify-content-between w-100">
				<div className="text-overflow-ellipsis">{option.label}</div>
				<span className={isCustom ? "chip chip--active" : "chip"}>
					{localize(isCustom ? LocKeys.CUSTOM : LocKeys.STANDARD)}
				</span>
			</div>
		</li>
	);
};

export default renderTemplateOption;
